import { render, staticRenderFns } from "./AlertBlock.vue?vue&type=template&id=7ad54dc2&scoped=true&"
import script from "./AlertBlock.vue?vue&type=script&lang=js&"
export * from "./AlertBlock.vue?vue&type=script&lang=js&"
import style0 from "./AlertBlock.vue?vue&type=style&index=0&id=7ad54dc2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad54dc2",
  null
  
)

export default component.exports